import { Outlet, useLocation } from "react-router-dom";
import Footer from "../components/Footer/Footer";
import Navbar from "../components/navbar/Navbar";
import Sidebar from "../components/Sidebar";

const FullLayout = () => {
  const location = useLocation();
  const hiddenRoutes = [
    "/login",
    "/sign-up",
    "/dashboard",
    "/management",
    "/quotation",
    "/invoice",
    "/setting",
  ];
  const adminRoutes = [
    "/dashboard",
    "/management",
    "/quotation",
    "/invoice",
    "/setting",
  ];

  const hideLayout = hiddenRoutes.includes(location.pathname);
  const adminLayout = adminRoutes.includes(location.pathname);

  return (
    <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
      {!hideLayout && <Navbar />}
      {adminLayout && <Sidebar />}
      <div style={{ flex: 1 }}>
        <Outlet />
      </div>
      {!hideLayout && <Footer />}
    </div>
  );
};

export default FullLayout;
